import { color } from "@mui/system";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";

const OrderStats = ({ analyticsData }) => {
  const navigate = useNavigate();

  const orderStats = [
    {
      label: "Pending Seller Shipment",
      description: "Order placed, seller hasn't created the shipment yet.",
      value: analyticsData?.pending_seller_shipment || 0,
      key: "pending_seller_shipment",
      color: "#EF4444",
    },
    {
      label: "Seller → Warehouse",
      description: "Shipment created by seller and on the way to warehouse.",
      value: analyticsData?.seller_to_warehouse_in_transit || 0,
      key: "seller_to_warehouse_in_transit",
      color: "#3B82F6",
    },
    {
      label: "Verification Pending",
      description:
        "Warehouse received the item. Admin verification is pending.",
      value: analyticsData?.verification_pending || 0,
      key: "verification_pending",
      color: "#F97316",
    },
    {
      label: "Verified",
      description: "Item verified. Buyer shipment has not been created yet.",
      value: analyticsData?.verification_approved || 0,
      key: "verification_approved",
      color: "#10B981",
    },
    {
      label: "Buyer Shipment",
      description: "Shipment is on the way from warehouse to buyer.",
      value: analyticsData?.buyer_shipment_in_transit || 0,
      key: "buyer_shipment_in_transit",
      color: "#0EA5E9",
    },
    {
      label: "Delivered",
      description: "Order has been successfully delivered to the buyer.",
      value: analyticsData?.delivered_to_buyer || 0,
      key: "delivered_to_buyer",
      color: "#16A34A",
    },
    {
      label: "Verification Rejected",
      description: "Verification failed. Return shipment is yet to be created.",
      value: analyticsData?.rejected_pending_return || 0,
      key: "rejected_pending_return",
      color: "#E11D48",
    },
    {
      label: "Return In Transit",
      description: "Return shipment is on the way back to the seller.",
      value: analyticsData?.return_in_transit || 0,
      key: "return_in_transit",
      color: "#8B5CF6",
    },
    {
      label: "Returned to Seller",
      description: "Returned shipment has been delivered to the seller.",
      value: analyticsData?.returned_to_seller || 0,
      key: "returned_to_seller",
      color: "#7C3AED",
    },
    {
      label: "Community Delivered",
      description: "Community orders successfully delivered.",
      value: analyticsData?.community_delivered_orders || 0,
      key: "community_delivered_orders",
      color: "#15803D",
    },
    {
      label: "Community In Transit",
      description: "Community orders currently in transit.",
      value: analyticsData?.community_in_transit_orders || 0,
      key: "community_in_transit_orders",
      color: "#0EA5E9",
    },
  ];

  return (
    <div className="dashboard-section mb-4">
      <h4 className="section-title mb-4">Orders Analytics</h4>

      <div className="row g-4">
        {orderStats?.map((item, index) => (
          <div
            className="col-12 col-md-6 col-lg-3 cursor-pointer"
            key={index}
            onClick={() => navigate(`/orders?search=${item?.key}`)}
          >
            <div
              className="analytics-card"
              style={{ borderLeft: `5px solid ${item.color}` }}
            >
               <p className="mb-1 fw-semibold">{item.label}</p>
              <small
                className="text-muted d-block mb-3"
                style={{
                  fontSize: "12px",
                  minHeight: "34px",
                  lineHeight: "1.35",
                }}
              >
                {item.description}
              </small>

              <h3>
                {item?.value && (
                  <CountUp end={Number(item.value)} duration={2} />
                )}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OrderStats;
